// O ano de serviço vai de setembro a agosto e leva o nome do ano em que
// termina: setembro de 2025 a agosto de 2026 é o ano de serviço 2026.
export function anoDeServico(ano, mes) {
    return mes >= 9 ? ano + 1 : ano;
}
export function mesesDoAnoDeServico(anoDeServico) {
    const meses = [];
    for (let m = 9; m <= 12; m++)
        meses.push({ ano: anoDeServico - 1, mes: m });
    for (let m = 1; m <= 8; m++)
        meses.push({ ano: anoDeServico, mes: m });
    return meses;
}
//# sourceMappingURL=anoDeServico.js.map